import { Extension } from '@tiptap/core';

interface CommandShortcutOptions {
  enabled: boolean;
}

// A lightweight TipTap extension to trigger the slash command menu with Mod-/ (Ctrl/Cmd + /)
// without wiring the shortcut in the React layer. It reuses the existing slash-command extension
// by inserting the trigger character '/' and cleaning it up on exit.
export const CommandShortcut = Extension.create<CommandShortcutOptions>({
  name: 'commandShortcut',

  addOptions() {
    return {
      // Allow enabling/disabling based on editor mode (e.g., agent mode)
      enabled: true,
    };
  },

  addStorage() {
    return {
      // If true, the slash that we programmatically insert should be removed when the
      // suggestion menu exits (user cancels). This is read by the slash-command extension.
      cleanOnExit: false as boolean,
    };
  },

  addKeyboardShortcuts() {
    return {
      'Mod-/': () => {
        if (!this.options.enabled) return false;
        console.log('⌨️ CommandShortcut: Mod-/ detected.');
        // Don't focus editor - let the slash menu handle focus
        const ev = new CustomEvent('open-slash-shortcut');
        console.log('⌨️ CommandShortcut: Dispatching open-slash-shortcut event.');
        document.dispatchEvent(ev);
        return true;
      },
      'Ctrl-/': () => {
        if (!this.options.enabled) return false;
        console.log('⌨️ CommandShortcut: Ctrl-/ detected.');
        // Don't focus editor - let the slash menu handle focus
        const ev = new CustomEvent('open-slash-shortcut');
        console.log('⌨️ CommandShortcut: Dispatching open-slash-shortcut event.');
        document.dispatchEvent(ev);
        return true;
      },
    };
  },
});
